import React, { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { wpService } from '../services/wpService';
import BlogCard from './BlogCard';
import { LanguageContext } from '../context/LanguageContext';
import './BlogList.css';

const BlogList = ({ limit = 10 }) => {
  const { lang } = useParams();
  const { t } = useContext(LanguageContext);
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPosts = async () => {
      setLoading(true);
      const data = await wpService.getPosts(lang, limit);
      setPosts(data);
      setLoading(false);
    };
    fetchPosts();
  }, [lang, limit]);

  if (loading) {
    return (
      <div className="blog-list-loading">
        <div className="blog-list-spinner"></div>
      </div>
    );
  }

  if (posts.length === 0) {
    return (
      <div className="blog-list-empty">
        <p className="blog-list-empty-text">{t('no_posts_found') || 'No posts found.'}</p>
      </div>
    );
  }

  return (
    <div className="blog-list-container">
      {posts.map(post => (
        <BlogCard key={post.id} post={post} />
      ))}
    </div>
  );
};

export default BlogList;